window.IsExperienceEditor = false;

$(document).ready(function () {
    if ($('body').hasClass('experience-editor')) {
        window.IsExperienceEditor = true;
    }
});